var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#322D29;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17453 -5906)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 18,
    height: 18,
    transform: "translate(17453 5906)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15.6,9.1h-9v1.8h9Zm1.8-6.3h-.9V1H14.7V2.8H7.5V1H5.7V2.8H4.8A1.792,1.792,0,0,0,3.009,4.6L3,17.2A1.8,1.8,0,0,0,4.8,19H17.4a1.805,1.805,0,0,0,1.8-1.8V4.6A1.805,1.805,0,0,0,17.4,2.8Zm0,14.4H4.8V7.3H17.4Zm-4.5-4.5H6.6v1.8h6.3Z",
    transform: "translate(17450.9 5905)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInfo);
export default __webpack_public_path__ + "static/media/icon_info.d544e663e9bffaf1f398d8f348d73414.svg";
export { ForwardRef as ReactComponent };